import React, {useEffect, useState} from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import {useFetchHook} from "../../hooks/useFetchHook";
import fetcher from "../../fetcher";
import useDidMountEffect from "../../hooks/useDidMountEffect";
import {BaseModal} from "../../components/BaseModal";
import {formatDate} from "../../utils/utils";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: 'white',
    boxShadow: 24,
    p: 4,
    minWidth: "600px",
    maxHeight: "100%",
    overflow: "scroll",
    padding: '31px 57px 60px 56px'
};

export const DealRebateModal = ( {name, description, expirationDate, isOpen, setIsOpen, rebate} ) => {
    const [rebateState, setRebateState] = useState(rebate)
    const [getRebateResponse, getRebate] = useFetchHook(fetcher.getRebate)

    useEffect(function fetchRebate(){
        getRebate(rebate.external_id)
    }, [])

    useDidMountEffect(function setFetchedRebate() {
        if (getRebateResponse && getRebateResponse?.data?.data) {
            setRebateState({...rebateState, full_description: getRebateResponse?.data?.data})
        }
    }, [getRebateResponse])

    if (!rebateState.full_description) return null;

    const full_description = rebateState.full_description

    return (
        <BaseModal
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            style={style}
        >
            <Stack
                direction="column"
                justifyContent="space-between"
                alignItems="left"
                className={''}
                >
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        className={''}
                    >
                        <Typography
                            gutterBottom
                            variant="h5"
                            component="div"
                            className={'DealRebateModal-name'}
                        >
                            {name}
                        </Typography>
                        {
                            expirationDate &&
                            <Typography
                                gutterBottom
                                variant="subtitle1"
                                component="div"
                                className={'DealRebateModal-name'}
                            >
                                Expires: {formatDate(new Date(expirationDate))}
                            </Typography>
                        }

                    </Stack>
                    <Divider className={'divider'} />
                    <Typography
                        gutterBottom
                        variant="subtitle1"
                        component="div"
                        className={'DealRebateModal-description'}
                    >
                        <strong>Amount:</strong> {rebateState.amount}
                    </Typography>
                    <Typography
                        gutterBottom
                        variant="subtitle1"
                        component="div"
                        className={'DealRebateModal-description'}
                    >
                        <strong>Eligibility:</strong> {full_description}
                    </Typography>
                    {/*<Typography*/}
                    {/*    gutterBottom*/}
                    {/*    variant="subtitle1"*/}
                    {/*    component="div"*/}
                    {/*    className={'DealRebateModal-description'}*/}
                    {/*>*/}
                    {/*    <strong>Stackable Rebates:</strong> {stackableRebates.map((rebate) => (<div key={rebate.Name}>{rebate.Name}</div>))}*/}
                    {/*</Typography>*/}
                </Stack>
        </BaseModal>
    )
}